import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { ThemeProvider } from "./context/ThemeContext";
import App from "./App";
import "./index.css";
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from "./pages/common/ErrorBoundary";
import "./i18n";

const future = { v7_startTransition: true, v7_relativeSplatPath: true };
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter future={future}>
       
        <ThemeProvider>
          <ErrorBoundary>
          <App />
          </ErrorBoundary>
          <Toaster position="top-right" reverseOrder={false} />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

